<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import QrcodeService from './QrcodeRequest';

export default {
  name: 'QrcodeList',
  extends: CrudListVue,
  data: () => ({
    requestClass: QrcodeService,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Cliente ID',
        value: 'clientId',
      },
      {
        text: 'Loja ID',
        value: 'storeId',
      },
      {
        text: 'Cardmais ID',
        value: 'userSystemId',
      },
      {
        text: 'SGV ID',
        value: 'sgvClientId',
      },
      {
        text: 'Título',
        value: 'title',
      },
      {
        text: 'Mensagem',
        value: 'message',
      },
      {
        text: 'Data de Criação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
